module.exports = __webpack_public_path__ + "static/media/dane-stuckey.d0deafac.jpg";